"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LeadershipVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="240905" id="welcome-to-atlantis-holding" className="bg-background text-foreground relative w-full overflow-hidden !bg-[url(https://causal-crawfish.10web.cloud/wp-content/uploads/2026/05/klassentrtmnt-1.png)]">
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_hero_network.png)]" aria-hidden="true" />
      <div className="absolute inset-0 bg-black/60" aria-hidden="true" />

      <div className="relative z-20 flex flex-col items-center pt-20">
        <img src="https://causal-crawfish.10web.cloud/wp-content/uploads/2026/05/klassentrtmnt-1.png" alt="Klass Entertainment Logo" className="object-contain !w-[150px] !h-[150px]" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/klass_entertainment_logo.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/klass_entertainment_logo.png-wvc-sizes" loading="lazy" decoding="async" />
      </div>

      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center min-h-[60vh] px-4 pb-40 font-sans text-[22pt] transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}><br /><br /><br />Welcome to Klass Entertainment<br /><br /><br /></div>
    </section>;
}